import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[260px]" }
const _hoisted_2 = { class: "flex items-center gap-1.5" }

import LlTooltip from '@/components/LlTooltip.vue';
import LlListItem from '@/components/LlListItem.vue';
import QboIcon from '@/components/QboIcon.vue';

// Not `disabled`: Vuetify's disabled list item drops pointer events, which would kill the tooltip.

export default /*@__PURE__*/_defineComponent({
  __name: 'LienPushBlockedItem',
  props: {
    reason: {},
    dataCy: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LlTooltip, { location: "left" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.reason), 1)
    ]),
    activator: _withCtx(() => [
      _createVNode(LlListItem, {
        color: "muted",
        "data-cy": __props.dataCy,
        "aria-disabled": "true",
        "aria-label": `Submit to QuickBooks unavailable. ${__props.reason}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(QboIcon, { size: 16 }),
            _cache[0] || (_cache[0] = _createTextVNode(" Submit to QuickBooks ", -1))
          ])
        ]),
        _: 1
      }, 8, ["data-cy", "aria-label"])
    ]),
    _: 1
  }))
}
}

})